import { Box } from '@mui/material'
import { useState } from 'react'
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import { PopoverOptionsMenuIcon } from '@/core/popover/options/PopoverOptionsMenuIcon.tsx'
import type { PopoverHooks } from '@/core/popover/popover-hooks.tsx'
import type { ObjectTypeModel } from '@/core/gql/gql-models-override.ts'
import type { TypeOptionPopoverItem } from './TypeOptionsPopoverItems.tsx'
import { RenamableNodeName } from '@/objects/collections-tree/HierarchyNodeName.tsx'
import { sidebarItemConfig } from '@/core/app-shell/sidebar/sidebarItemConfig.ts'

export interface TypeListItemProps {
  type: ObjectTypeModel
  optionPopoverHooks: PopoverHooks<TypeOptionPopoverItem>
  onRenameSubmit: (typeId: number, name: string) => void
  onDeleteRequested: (typeId: number) => void
  onTypeClicked: (typeId: number) => void
}

const config = sidebarItemConfig

export function TypeListItem({
  type,
  optionPopoverHooks,
  onRenameSubmit,
  onDeleteRequested,
  onTypeClicked,
}: TypeListItemProps) {
  const [isRenaming, setIsRenaming] = useState(false)

  function onPopoverOptionSelected(option: TypeOptionPopoverItem) {
    switch (option) {
      case 'Rename':
        setIsRenaming(true)
        break
      case 'Delete':
        onDeleteRequested(type.id)
        break
    }
  }

  function handleRenameSubmit(name: string) {
    onRenameSubmit(type.id, name)
  }

  return (
    <Box
      className="sidebarMenuListItem"
      sx={{ ...config.itemSx, justifyContent: 'space-between', cursor: 'pointer' }}
      onClick={() => onTypeClicked(type.id)}
    >
      <CategoryOutlinedIcon sx={config.iconSx} />
      <RenamableNodeName
        initialName={type.name}
        isRenaming={isRenaming}
        setIsRenaming={setIsRenaming}
        onRenameSubmit={handleRenameSubmit}
      />
      <PopoverOptionsMenuIcon
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.stopPropagation()
          optionPopoverHooks.openPopover(e.currentTarget, onPopoverOptionSelected)
        }}
      />
    </Box>
  )
}
